/**
 * Tooltip.js
 *
 */


import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({



	propTypes: {
		className: React.PropTypes.string,
		label: React.PropTypes.string.isRequired,
		show: React.PropTypes.bool,
		touch: React.PropTypes.bool,
		position: React.PropTypes.oneOf(['top','bottom','left','right']),
		compact: React.PropTypes.bool
	},

	getDefaultProps(){
		return {
			position: 'bottom',
			compact: false
		};
	},

	componentDidMount() {
		this._setRippleSize();
	},

	componentDidUpdate(prevProps, prevState) {
		this._setRippleSize();
	},

	render() {
			var {
				className,
				label,
			} = this.props;
			var classes = ClassNames('lui-tooltip', className, {
				'lui-is-shown': this.props.show,
				'lui-is-touch': this.props.touch,
				'lui-is-top' : this.props.position === 'top',
				'lui-is-bottom' : this.props.position === 'bottom',
				'lui-is-left' : this.props.position === 'left',
				'lui-is-right' : this.props.position === 'right',
				'lui-is-compact' : this.props.compact

			});

	return (
		<div  className={classes}>
			<div ref="ripple" className="lui-tooltip-ripple" />
			<span className="lui-tooltip-label">{this.props.label}</span>
		</div>
		);
	},

	_setRippleSize() {
		var ripple = this.refs.ripple.getDOMNode();
		var tooltipSize = this.getDOMNode().offsetWidth;
		var ripplePadding = this.props.touch ? 45 : 20;
		var rippleSize = tooltipSize + ripplePadding + 'px';

		if (this.props.show) {
			ripple.style.height = rippleSize;
			ripple.style.width = rippleSize;
		} else {
			ripple.style.width = '0px';
			ripple.style.height = '0px';
		}
	}
});



/** WEBPACK FOOTER **
 ** ./src/components/tooltip/Tooltip.js
 **/